import { setSessionStorageItem, getSessionStorageItem } from '../../../DAL/storage-provider';
import { StateInterface } from '../interfaces/interfaces';

const storageName = 'react-jplist';

/**
 * save to storage
 * @param {object} updatedState
 */
export const saveToStorage = (updatedState: StateInterface) => {
    setSessionStorageItem(storageName, {
        sortType: updatedState.sortType,
        sortProperty: updatedState.sortProperty,
        sortOrder: updatedState.sortOrder,
        layoutMode: updatedState.layoutMode
    })
};

/**
 * get data from local storage
 */
export const getFromStorage = () => {
    let data = getSessionStorageItem(storageName);

    try{
        data =JSON.parse(data);
    }
    catch(ex){}

    return data;
};
